import { AfterViewInit, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FetchJsonService } from './../../services/fetch-json.service';
import { ColumnReorderEvent, ColumnResizeEvent } from 'toolbox-lib/packages/component-library/dist';

@Component({
  selector: 'app-grid-example',
  templateUrl: './grid-example.component.html',
  styleUrls: ['./grid-example.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class GridExampleComponent implements AfterViewInit, OnInit {

  public movies: any[];
  public filteredMovies: any[];
  public sortState: any = {
    column: null,
    direction: null
  };
  public filterValue = '';

  constructor(private fetchJsonService: FetchJsonService) { }

  ngOnInit() {
    this.fetchJsonService.getMovies().subscribe(res => {
      this.movies = res;
      this.filteredMovies = this.movies.concat();
    });
  }
  ngAfterViewInit() {

  }

  getSortState(varName: string): string {
    if (this.sortState.column !== varName) {
      return 'fa-arrows-alt-v';
    }
    if (this.sortState.direction === null) {
      return 'fa-arrows-alt-v';
    }
    if (this.sortState.direction === 'up') {
      return 'fa-long-arrow-alt-up';
    } else {
      return 'fa-long-arrow-alt-down';
    }
  }

  sortColumnOn(varName: string): void {
    if (this.sortState.column === varName) {
      if (this.sortState.direction === 'down') {
        this.sortState.direction = 'up';
      } else {
        this.sortState.direction = 'down';
      }
    } else {
      this.sortState.direction = 'down';
    }
    this.sortState.column = varName;

    this.filterAndSortByValue();
  }


  dragDropFilter(el: HTMLElement): boolean {
    return el.tagName !== 'APP-RESIZE-GRIP';
  }

  filterMovies(e: KeyboardEvent): void {
    const target: HTMLInputElement = e.target as HTMLInputElement;
    this.filterValue = target.value;
    this.filterAndSortByValue();
  }

  filterAndSortByValue(): void {
    const sortedMovies: any[] = this.movies.concat();
    const direction = this.sortState.direction === 'up' ? 1 : -1;
    if (this.sortState.column !== null) {
      sortedMovies.sort((movie1, movie2) => {
        if (movie1[this.sortState.column] < movie2[this.sortState.column]) {
          return 1 * direction;
        }
        if (movie2[this.sortState.column] < movie1[this.sortState.column]) {
          return -1 * direction;
        }
        return 0;
      });
    }

    this.filteredMovies = sortedMovies.filter(movie => {
      return movie.title.toLowerCase().includes(this.filterValue.toLowerCase()) ||
      movie.director.toLowerCase().includes(this.filterValue.toLowerCase()) ||
      movie.year.toLowerCase().includes(this.filterValue.toLowerCase()) ||
      movie.status.toLowerCase().includes(this.filterValue.toLowerCase());
    });
  }

  onColumnResizeStart(e: ColumnResizeEvent): void {
    // console.log('resize start');
    // console.log(e);
  }
  onColumnResize(e: ColumnResizeEvent): void {
    // console.log('resize');
  }

  onColumnResizeEnd(e: ColumnResizeEvent): void {
    // console.log('resize end');
  }
  onColumnReorderStart(e: ColumnReorderEvent): void {
    // console.log('reorder start');
  }
  onColumnReorder(e: ColumnReorderEvent): void {
    // console.log('reorder');
  }
  onColumnReorderEnd(e: ColumnReorderEvent): void {
    // console.log('reorder end');
  }
  /**/


}
